<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_669')}}</div>
    <div slot="body">
      <page-list
        :list="list"
        :columns="columns" />
    </div>
    <div slot="footer">
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { getTimeTableColumn } from '@/utils/common/tableColumn'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'ViewHistoryExchangeRateDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      list: this.$list.createList(this, {
        resource: 'billing_exchange_rates',
        idKey: 'rate',
        getParams: {
          src: this.params.data[0].src,
          dest: this.params.data[0].dest,
        },
      }),
      columns: [
        {
          field: 'src',
          title: this.$t('scope.text_670'),
          minWidth: 80,
        },
        {
          field: 'dest',
          title: this.$t('scope.text_671'),
          minWidth: 80,
        },
        {
          field: 'rate',
          title: this.$t('scope.text_666'),
          minWidth: 80,
        },
        getTimeTableColumn({
          field: 'date',
          title: this.$t('scope.text_310'),
        }),
      ],
    }
  },
  created () {
    this.list.fetchData()
  },
}
</script>
